<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Юридическая информация</span>
        <h1 class="page-hero__title">Политика конфиденциальности</h1>
        <p class="page-hero__text">Как мы обрабатываем персональные данные пользователей сервиса CandB.pro</p>
      </div>
    </div>

    <section class="section">
      <div class="container legal-content">
        <p class="legal-meta">Редакция от 26 августа 2026 г.</p>

        <h2>1. Общие положения</h2>
        <p>
          Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии
          с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
          и определяет порядок обработки персональных данных и меры по обеспечению их безопасности,
          предпринимаемые оператором сервиса <strong>CandB.pro</strong> — Обществом с ограниченной
          ответственностью «Степ Менеджмент» (ООО «Степ М») (далее — Оператор).
        </p>
        <p class="legal-req">
          <strong>Оператор:</strong> ООО «Степ М» (полное наименование — Общество с ограниченной
          ответственностью «Степ Менеджмент»)<br>
          ИНН 5040202027, КПП 504001001, ОГРН 1265000059500<br>
          Адрес: 140120, Московская область, Раменский м.о., пгт. Ильинский, ул. Чкалова, д. 2, кв. 33
        </p>
        <p>
          Использование сайта <a href="https://candb.pro">candb.pro</a> и сервиса CandB.pro
          означает безоговорочное согласие пользователя с настоящей Политикой и указанными в ней
          условиями обработки его персональных данных.
        </p>

        <h2>2. Какие данные мы собираем</h2>
        <p>Оператор собирает и обрабатывает следующие категории персональных данных:</p>
        <ul>
          <li>фамилия, имя, отчество;</li>
          <li>контактный номер телефона;</li>
          <li>адрес электронной почты;</li>
          <li>название и реквизиты организации (для b2b-заявок);</li>
          <li>должность и подразделение (в личном кабинете сотрудника);</li>
          <li>служебные данные о премиях, окладах, показателях KPI — только в рамках выполнения договора с организацией-клиентом;</li>
          <li>технические данные: IP-адрес, тип браузера, страницы посещения (через cookies и системы веб-аналитики).</li>
        </ul>

        <h2>3. Цели обработки</h2>
        <ul>
          <li>предоставление доступа к сервису CandB.pro и его функциональности;</li>
          <li>обработка заявок на демонстрацию и обратной связи;</li>
          <li>исполнение договора с организацией-клиентом;</li>
          <li>информирование пользователя об обновлениях сервиса (с возможностью отказа);</li>
          <li>обеспечение технической поддержки;</li>
          <li>соблюдение требований законодательства РФ.</li>
        </ul>

        <h2>4. Сроки обработки</h2>
        <p>
          Персональные данные обрабатываются в течение срока действия договора с организацией-клиентом,
          а в части лидов — в течение 3 (трёх) лет с момента последнего взаимодействия,
          если иное не предусмотрено законодательством.
        </p>

        <h2>5. Передача третьим лицам</h2>
        <p>
          Оператор не передаёт персональные данные третьим лицам, за исключением случаев,
          предусмотренных законодательством РФ, либо при получении явного согласия субъекта данных.
          Передача данных в адрес поставщиков инфраструктуры (хостинг, сервисы рассылок) осуществляется
          в объёме, минимально необходимом для оказания соответствующих услуг.
        </p>

        <h2>6. Меры безопасности</h2>
        <p>
          Оператор принимает технические и организационные меры, необходимые и достаточные
          для защиты персональных данных от неправомерного или случайного доступа:
          шифрование каналов передачи (TLS), хранение в защищённых дата-центрах на территории РФ,
          разграничение прав доступа, регулярный аудит безопасности.
        </p>

        <h2>7. Права пользователя</h2>
        <p>Субъект персональных данных имеет право:</p>
        <ul>
          <li>получать информацию об обработке своих данных;</li>
          <li>требовать уточнения, блокирования или уничтожения данных;</li>
          <li>отзывать согласие на обработку;</li>
          <li>обжаловать действия оператора в Роскомнадзоре.</li>
        </ul>

        <h2>8. Использование cookies</h2>
        <p>
          Сайт candb.pro использует файлы cookies для сохранения сессии, настроек пользователя
          и сбора обезличенной статистики посещений. Вы можете отключить cookies в настройках
          браузера, однако часть функциональности сайта при этом может стать недоступна.
        </p>
        <p>
          Для обезличенной статистики и оценки эффективности рекламы на сайте установлены
          счётчики Яндекс.Метрики и VK Рекламы (пиксель top.mail.ru). Они собирают технические
          данные о посещении — страницы, источник перехода, тип устройства — и используются
          в обезличенном виде.
        </p>

        <h2>9. Контакты</h2>
        <p>
          По вопросам обработки персональных данных обращайтесь:
          <br><a href="mailto:info@candb.pro">info@candb.pro</a>
          <br><a href="tel:+79939037308">+7 993 903-73-08</a>
        </p>
        <p class="legal-req">
          ООО «Степ М»<br>
          ИНН 5040202027, КПП 504001001, ОГРН 1265000059500<br>
          140120, Московская область, Раменский м.о., пгт. Ильинский, ул. Чкалова, д. 2, кв. 33
        </p>
        <p>
          Настоящая Политика может изменяться. Актуальная редакция всегда доступна
          по адресу <a href="https://candb.pro/policy">candb.pro/policy</a>.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default { name: 'PolicyPage' }
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title { font-size: 2.5rem; font-weight: 800; margin: 12px 0 16px; }
.page-hero__text { font-size: 1.125rem; opacity: 0.85; max-width: 620px; }

.legal-content { max-width: 780px; }
.legal-meta { color: var(--gray); font-size: 0.875rem; margin-bottom: 32px; }
.legal-req {
  background: var(--bg-soft, #f5f7fa);
  border-left: 3px solid var(--primary);
  border-radius: 8px;
  padding: 16px 18px;
  font-size: 0.9375rem;
  line-height: 1.7;
}

.legal-content h2 {
  font-size: 1.375rem; font-weight: 700; margin: 32px 0 12px; color: var(--dark);
}
.legal-content p, .legal-content li {
  color: var(--gray); line-height: 1.7; font-size: 1rem; margin-bottom: 12px;
}
.legal-content ul { padding-left: 22px; margin-bottom: 16px; }
.legal-content a { color: var(--primary); text-decoration: none; }
.legal-content a:hover { text-decoration: underline; }

@media (max-width: 768px) {
  .page-hero__title { font-size: 1.875rem; }
}
</style>
